import {zIndexEditorLeftBar} from 'crazyEditor/core/globals';
import * as Colors from 'material-ui/styles/colors';

export const LEFT_BAR_EXPANDED_WIDTH = '160px';
export const LEFT_BAR_BACKGROUND_COLOR = Colors.grey600;
export const LEFT_BAR_ACTIVE_COLOR = Colors.white;
export const TOP_LEVEL_MENU_WIDTH = 100;
export const TOP_LEVEL_MENU_HEIGHT = 80;

const container = {
  width: TOP_LEVEL_MENU_WIDTH,
  position: 'fixed',
  left: 0,
  bottom: 0,
  boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
  zIndex: zIndexEditorLeftBar,
};


export default {
  container: container,
  mobileContainer: {...container, backgroundColor: LEFT_BAR_BACKGROUND_COLOR},
  firstLevelMenuContainer: {
    width: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    backgroundColor: LEFT_BAR_BACKGROUND_COLOR,
  },
  secondLevelMenuContainer: {
    boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
    position: 'absolute',
    zIndex: -1,
    left: '100%',
    top: 0,
    width: 200,
    backgroundColor: LEFT_BAR_ACTIVE_COLOR,
    height: '100%',
  },
  containerExpanded: {
    width: LEFT_BAR_EXPANDED_WIDTH
  },
  menuContainer: {
    boxSizing: 'border-box',
    padding: 0,
    marginTop: 0,
    listStyle: 'none'
  },
  menuContainerWithDivider: {
    borderBottom: `1px solid ${Colors.grey700}`
  },
  // used in mobile for hidden elements
  menuTitle: {
    textAlign: 'center',
    color: '#b3b3b3',
    userSelect: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '12px',
    marginTop: 25,
    marginBottom: 9,
    display: 'block',
    fontWeight: 'medium'
  },
  subheader: {
    cursor: 'default',
    fontSize: 14,
    textTransform: 'uppercase',
    paddingLeft: 2,
    paddingRight: 2,
    marginLeft: 15,
    marginRight: 15,
    marginTop: 10,
    marginBottom: 2,
    borderBottom: `1px solid ${Colors.grey300}`,
    lineHeight: '32px',
    width: 'auto',
    whiteSpace: 'nowrap'
  }
};
